/** 
 * Copyright © INOVUA TRADING.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _reactDom = require("react-dom");
var _default = function _default() {
  var commited = false;
  var fns = [];
  var queue = function queue(fn) {
    fns.push(fn);
  };
  queue.commit = function (extraFn) {
    if (commited) {
      return Promise.resolve(true);
    }
    commited = true;
    return new Promise(function (resolve) {
      (0, _reactDom.unstable_batchedUpdates)(function () {
        if (extraFn) {
          fns.push(extraFn);
        }
        fns.forEach(function (fn) {
          return fn();
        });
        fns = undefined;
        resolve(true);
      });
    });
  };
  return queue;
};
exports.default = _default;